<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Permission Denied</h1>
              <p class="text-lead text-white">{{message ? message : "Please contact a member of the account or project to be invited."}}</p>
            </div>
          </div>
          <div class="text-center mb-4">
              <h3 class="text-lead text-white">Already Invited?</h3>
          </div>
          <div class="text-center">
              <b-button size="sm" variant="secondary" @click="goToInvites()">Go to Invites</b-button>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    async goToInvites() {
      // TODO
    },
  },
};
</script>
<style>

</style>
